import { withTranslation } from 'react-i18next';
import Links from './Links.layout';

export default withTranslation('login')(Links);
